'use strict';
import Price from './price';
export default class PriceOriginal extends Price {
    setElement() {
        let form = document.createElement('div');
        form.classList.add('priceform');
        form.append(this.Price.getElement());
        form.append(this.Rounding.getElement());
        this.element = form;
    }
    getValue() {
        return {
            price: this.Price.getValue(),
            rounding: this.Rounding.getValue()
        };
    }
}
